import { Component } from '@angular/core';

import { ApInputSkeletonComponent } from '@ap/skeleton';
import { ApParagraphSkeletonComponent } from '@ap/skeleton';
import { ApButtonSkeletonComponent } from '@ap/skeleton';

/**
 * @ngdoc component
 * @name ApBrowserSkeletonComponent
 */
@Component({
    selector: 'ap-browser-skeleton',
    standalone: true,
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    imports: [ApInputSkeletonComponent, ApParagraphSkeletonComponent, ApButtonSkeletonComponent]
})
export class ApBrowserSkeletonComponent {}
